import React, { useState } from 'react';

import { useAutoFilters } from '../hooks/useAutofilters';
import useBuilderConstructorGridInputs from '../hooks/useBuilderConstructorGridInputs';
import useGridLayoutTracking from '../hooks/useGridLayoutTracking';
import useInGridAssets from '../hooks/useInGridAssets';
import useProductGridData from '../hooks/useProductGridData';

import MobileGridDiscoveryGuide from './DiscoveryGuide/MobileGridDiscoveryGuide';
import GridLayoutTrackingProvider from './GridLayoutTrackingProvider';
import MobileGridCategoryDropdown from './MobileGridCategoryDropdown/MobileGridCategoryDropdown';
import MobileGridHeader from './MobileGridHeader';
import MobileGridVirtualScroll from './MobileGridVirtualScroll';

const MobileGridLayout = () => {
  const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);
  const {
    products,
    totalNumResults,
    fetchNextPage,
    hasNextPage,
    isCioBrowseFetching,
    isCioBrowseLoading,
    cioFacets,
    cioFilterName,
    cioFilterValue,
  } = useProductGridData();

  const { mergedAssetsAndProducts } = useInGridAssets({ products });
  const { builderState, gridGender } = useBuilderConstructorGridInputs();

  useAutoFilters({ builderState, gridGender, cioFacets });

  const { trackingTags } = useGridLayoutTracking({
    totalNumResults,
    cioFilterName,
    cioFilterValue,
  });

  const handleOpenFilterDrawer = () => {
    setIsFilterDrawerOpen(true);
  };

  return (
    <GridLayoutTrackingProvider>
      <div {...trackingTags}>
        <MobileGridDiscoveryGuide />
        <MobileGridCategoryDropdown />
        <MobileGridHeader
          isFilterDrawerOpen={isFilterDrawerOpen}
          setIsFilterDrawerOpen={setIsFilterDrawerOpen}
        />
        <MobileGridVirtualScroll
          virtualList={mergedAssetsAndProducts}
          totalNumResults={totalNumResults}
          fetchNextPage={fetchNextPage}
          hasNextPage={hasNextPage}
          isCioBrowseFetching={isCioBrowseFetching}
          isCioBrowseLoading={isCioBrowseLoading}
          handleOpenFilterDrawer={handleOpenFilterDrawer}
        />
      </div>
    </GridLayoutTrackingProvider>
  );
};

export default MobileGridLayout;
